<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="链接名称" prop="title">
						<el-input v-model="formInline.title" placeholder="请输入链接名称" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="描述" prop="linkDescribe">
						<el-input v-model="formInline.linkDescribe" placeholder="请输入描述" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="投放链接ID" prop="tfid">
						<el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="代理商姓名" prop="agentId" v-if="!isAgent">
						<el-select v-model="formInline.agentId" placeholder="请选择代理商姓名" clearable @change="search" filterable >
							<el-option
								v-for="item in agentIdOptions"
								:key="item.id"
								:label="item.nickName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="注册时间：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="" label="序号" width="100">
						<template slot-scope="scope">
							<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="代理商信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>代理商姓名：{{scope.row.agentName}}</p>
								<p>小程序名称：{{scope.row.appName}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="投放链接信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>链接ID：{{scope.row.id}}</p>
								<p>链接名称：{{scope.row.title}}</p>
								<p>描述：{{scope.row.linkDescribe}}</p>
								<p>剧名：{{scope.row.svName}}</p>
								<p>创建时间：{{ scope.row.addTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="总用户数据" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>总用户数: {{scope.row.totalUserNumber || 0}}</p>
								<p>总充值人数: {{scope.row.totalRechargeUserNumber || 0}}</p>
								<p>总充值金额: {{scope.row.totalMoney || 0}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="订单数">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总订单数：{{scope.row.totalRechargeNumber || 0}}</p>
								<p>未支付数：{{scope.row.totalRechargeNoPayNumber || 0}}</p>
								<p>支付数：{{scope.row.totalRechargePayNumber || 0}}</p>
								<p>充值成功率：{{scope.row.rechargePayRate || 0.00}}%</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<!--<el-pagination @current-change="handleCurrentChange" :page-size="tableData.pageSize"-->
					<!--background :current-page="currentPage" :total="tableData.totalNum">-->
					<!--</el-pagination>-->
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" width="1600px">
			<div class="top-search">
				<el-form :inline="true" :model="detailformInline" ref="detailformInline" size="small" class="demo-form-inline">
					<el-form-item label="时间：">
						<el-date-picker
							v-model="detailDataTime"
							class="pickerData"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="detailSearch">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="detailSearch">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="detailResetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableLinkData.result" border stripe style="width: 100%;" height="100%" class="tableStyle" v-loading="linkLoading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{(tableLinkData.pageNo - 1)* tableLinkData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="addTime" label="日期" width="100"></el-table-column>
					<el-table-column prop="title" label="代理商信息" width="180">
						<template slot-scope="scope">
							<div class="td-info">
								<p>代理商姓名：{{scope.row.agentName}}</p>
								<p>小程序名称：{{scope.row.appName}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="投放链接信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>链接ID：{{scope.row.tfid}}</p>
								<p>链接名称：{{scope.row.title}}</p>
								<p>描述：{{scope.row.linkDescribe}}</p>
								<p>剧名：{{scope.row.svName}}</p>
								<p>创建时间：{{ scope.row.linkAddTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="当日总数据" width="140">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日充值人数：{{scope.row.todayUserRechargeNumber}}</p>
								<p>当日充值笔数：{{scope.row.todayRechargeNumber}}</p>
								<p>当日充值：{{scope.row.todayRecharge}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="新用户数据">
						<template slot="header">
							<el-tooltip class="item" effect="dark" placement="top">
								<div slot="content">新用户人均充值：新用户充值金额/新用户数<br/>新用户付费率：新用户充值人数/新用户数*100%</div>
								<p>新用户数据</p>
							</el-tooltip>
						</template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>新用户数: {{scope.row.userNumber}}</p>
								<p>新用户充值人数: {{scope.row.newUserRechargeNumber}}</p>
								<p>新用户充值金额:  {{scope.row.newUserRecharge}}</p>
								<p>新用户人均充值:  {{scope.row.newUserAverageRecharge}}</p>
								<p>新用户付费率:  {{scope.row.newUserRechargeOdds}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="广告数据" width="220">
						<template slot="header">
							<el-tooltip class="item" effect="dark" placement="top">
								<div slot="content">
									有效广告曝光总数ipu：有ECPM的广告次数<br/>
									当日新用户平均ECPM：ECPM之和/当日新用户数<br/>
									当日总平均ECPM：ECPM之和/当日总用户数<br/>
									当日广告预估收入：平均ECPM*有效IPU/1000<br/>
								</div>
								<p>广告数据</p>
							</el-tooltip>
						</template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>有效广告曝光总数IPU：{{scope.row.ipu}}</p>
								<p>当日新用户平均ECPM：{{scope.row.newUserECPM}}</p>
								<p>当日总平均ECPM：{{scope.row.ecpm}}</p>
								<p>当日广告预估总收入：{{scope.row.income}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="回传信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日广告完播总次数：{{scope.row.postbackNumber}}</p>
								<p>当日广告已回传笔数：{{scope.row.postbackNumberBefore}}</p>
								<p>当日广告回传人数：{{scope.row.postbackUserNumber}}</p>
								<p>当日付费回传笔数：{{scope.row.payPostNumber}}</p>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
						@current-change="handleCurrentChangeLink"
						@size-change="handleSizeChangeLink"
						:page-sizes="[20, 50, 100, 200, 500]"
						:page-size="tableLinkData.pageSize"
						background
						:current-page="linkCurrentPage"
						layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableLinkData.totalNum">
					</el-pagination>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="margin-top: 20px;">
				<el-button type="primary" @click="closeDialogBtn">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { list, agentlist, linklist } from "@/api/dysvzk/data/link";
export default {
	data() {
		return {
			loading: false,
			linkLoading:false,
			dataTime: [],
			formInline: {
				title: '',
				linkDescribe: '',
				tfid: '',
				agentId: '',
				startTime: '',
				endTime: '',
				appid: localStorage.getItem('appId'),
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			tableLinkData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			linkCurrentPage:1,
			dialogInfoVisible: false,
			rowForm: {},
			agentIdOptions:[],
			isAgent:false,
			linkId:'',
			detailformInline:{
				startTime: '',
				endTime: '',
			},
			detailDataTime:[],
		}
	},
	computed: {},
	watch: {
	},
	mounted: function() {
		if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId){
			this.isAgent = true
			this.formInline.appid = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
		}
		this.loading = true
		this.getTableData()
		this.getAgentList()
	},
	methods: {
		// 从组件获取appid
		getAppId(data) {
			this.formInline.appid = data
			this.loading = true
			this.getTableData()
		},
		search () {
			this.currentPage = 1
			this.loading = true
			this.getTableData()
		},
		resetQuery: function(){
			this.loading = true
			this.$refs['formInline'].resetFields()
			this.dataTime = []
			this.getTableData()
		},
		// pageSize切换
		handleSizeChange (val) {
			this.tableData.pageSize  = val
			this.currentPage = 1
			this.loading = true
			this.getTableData()
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.loading = true
			this.getTableData()
		},
		// 详情pageSize切换
		handleSizeChangeLink (val) {
			this.tableData.pageSize  = val
			this.linkCurrentPage = 1
			this.linkLoading = true
			this.getTableLinkData(this.linkId)
		},
		handleCurrentChangeLink(value) {
			this.linkCurrentPage = value
			this.linkLoading = true
			this.getTableLinkData(this.linkId)
		},
		//详情搜索和重置
		detailSearch() {
			this.linkLoading = true,
			this.linkCurrentPage = 1
			this.getTableLinkData(this.linkId)
		},
		detailResetQuery(){
			this.$refs['detailformInline'].resetFields()
			this.linkLoading = true,
			this.detailDataTime = []
			this.getTableLinkData(this.linkId)
		},
		handleLook(row) {
			this.dialogInfoVisible = true
			this.rowForm = row
			this.linkLoading = true
			this.linkId = row.id
			this.detailDataTime = this.dataTime
            this.linkCurrentPage = 1
			this.getTableLinkData(row.id)
		},
		// 列表
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
			this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			linklist(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableData = response.data.content
					this.loading = false
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		//获取代理商列表
		getAgentList(){
			agentlist().then(response => {
				if (response.data.head.flag === 0) {
					this.agentIdOptions = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		//获取链接详情列表
		getTableLinkData(tfid){
			let json2 = {
				pageNo: this.linkCurrentPage,
				pageSize: this.tableLinkData.pageSize
			};
			// this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
			// this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
			const startTime = this.detailDataTime ? this.detailDataTime[0] : ''
			const endTime = this.detailDataTime ? this.detailDataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2,tfid,startTime,endTime };
			console.log("paramJson",paramJson)
			list(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableLinkData = response.data.content
					this.linkLoading = false
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		//详情弹窗关闭
		closeDialogBtn(){
			this.dialogInfoVisible = false
		}

	}
}
</script>
